import { bool, number, string } from 'prop-types';
import React from 'react';
import { GoAlert, GoCalendar } from 'react-icons/go';
import { Alert, Button, Popover, PopoverBody, PopoverHeader } from 'reactstrap';

import Details from './Details';

function getButtonColor(missingSKUsMessage) {
  if (missingSKUsMessage) return 'warning';
  return 'secondary';
}

class DetailsPopover extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { isOpen: false };

    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle() {
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }));
  }

  render() {
    const { id, hidden, missingSKUsMessage, missingSKUsLoading, isDisabled } =
      this.props;
    if (hidden && !missingSKUsMessage) {
      return null;
    }

    const buttonId = `quoteLines-${id}-detailsButton`;
    return (
      <>
        <Button
          id={buttonId}
          type="button"
          onClick={this.handleToggle}
          color={getButtonColor(missingSKUsMessage)}
          outline={!missingSKUsMessage}
          className="px-2 py-1"
          disabled={isDisabled}
        >
          <GoCalendar className="va-n1" />
        </Button>
        <Popover
          trigger="legacy"
          target={buttonId}
          isOpen={this.state.isOpen}
          toggle={this.handleToggle}
          placement="top"
          boundariesElement="window"
          className="popover-xl"
        >
          <PopoverHeader>Quote Line Details</PopoverHeader>
          <PopoverBody>
            {!hidden && <Details {...this.props} />}
            {(missingSKUsMessage || missingSKUsLoading) && (
              <Alert color="warning" className="mb-0">
                <GoAlert className="text-warning" />{' '}
                <span>
                  {missingSKUsLoading
                    ? 'Checking whether there are any SKUs…'
                    : missingSKUsMessage}
                </span>
              </Alert>
            )}
          </PopoverBody>
        </Popover>
      </>
    );
  }
}

DetailsPopover.propTypes = {
  id: number.isRequired,
  hidden: bool.isRequired,

  missingSKUsMessage: string,
  missingSKUsLoading: bool,
  isDisabled: bool,
};

DetailsPopover.defaultProps = {
  missingSKUsMessage: '',
  missingSKUsLoading: false,
  isDisabled: false,
};

export default DetailsPopover;
